import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { OpcionModel } from '../Global/Opcion.model';
import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';

import * as TerceroNewModel from './Tercero.model';
import * as SucursalNewModel from './Sucursal.model'

declare function validateisEmail(email: string): boolean;

@Component({
	selector : 'TerceroForm',
	templateUrl : './TerceroNew.component.html'
})


export class TerceroNewComponent  {

	// ~~~~~ Variables para el manejo de permisos ~~~~~ //
	public btnAgregar:boolean;
	public btnEditar:boolean;
	public btnEliminar:boolean;
	public btnConsultar:boolean;
	
	// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //

	public form:FormGroup;
	public formErrors:any;

	public tercero:TerceroNewModel.TerceroModel;
	public tiposId:Array<OpcionModel>;
	public tiposPersonas:Array<OpcionModel>;
	public tiposContribuyente:Array<OpcionModel>;
	public listaNegocios:Array<OpcionModel>;
	public tiposTributo:Array<OpcionModel>;
	
	
	public sucursal: SucursalNewModel.SucursalModel;
	public ciudades:Array<OpcionModel>;
	public departamentos:Array<OpcionModel>;
	public paises: Array<OpcionModel>;
	public registroSucursal;
	public principal:boolean;

	
	public registroTercero;
	public mensaje:string;
	public cantidadSucursales;
	public creaSucursal:boolean;
	public responsabilidadesFiscales = new Array();
	public codigosPostales = new Array();
	public bloquearValor:boolean = true;

	public ocultar: boolean = false;
	


	constructor(private formBuilder:FormBuilder,
		private _serviciosGenerales:ServiciosGenerales, 
		private snackBar: MatSnackBar,
		private _route: ActivatedRoute, 
		private _router:Router){

		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.btnAgregar = _serviciosGenerales.seguridad.isAgregar();
		this.btnEditar = _serviciosGenerales.seguridad.isEditar();
		this.btnEliminar = _serviciosGenerales.seguridad.isEliminar();
		this.btnConsultar = _serviciosGenerales.seguridad.isConsultar();
		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.snackBar.dismiss();

		this.formErrors = {
			
			tipoId 	   		  : {},
			numId      		  : {},
			digito        	  : {},
			nombre     		  : {},
			tipoPersona	      : {},
			tipoContribuyente : {},
			sucursal : {},
			direccion : {},
			pais : {},
			departamento : {},
			ciudad:{},
			telefono:{},
			correo:{},
			tipoTributo      : {},
			responsibilidades : {},
			codigoPostal : {},
			deptoextranjero :{},
			ciudadextranjero :{}
		};

		this.tiposId = new Array();
		this.tiposPersonas = new Array();
		this.tiposContribuyente = new Array();
		this.listaNegocios = new Array();
		this.tercero = new TerceroNewModel.TerceroModel(new TerceroNewModel.DefTiposdocumentos(""),
			new TerceroNewModel.MchTercerosId("", "","", 0), 
			0,"","","",0,0,new TerceroNewModel.DefTipospersona("1"),
			/*new TerceroNewModel.ParamNegocios(new TerceroNewModel.ParamNegociosId("", 0)),*/
			new TerceroNewModel.DefContribuyentes(""), '', '');

		this.principal = false;
		this.ciudades = new Array();
		this.departamentos = new Array();
		this.paises = new Array();
		this.sucursal = new SucursalNewModel.SucursalModel(new SucursalNewModel.MchSucursalesId("","","","")
			,"","",new SucursalNewModel.DefCiudades(new SucursalNewModel.DefCiudadesId(0, "",""), ""),"",0,0,0,0, '','','');
		this.tiposTributo = new Array();

		
		
		
	}


	ngOnInit(){

		this.inicializarForm();
		

		this.form.valueChanges.subscribe(() => {
			this.onFormValuesChanged();
		});




		/*Se carga la informacion de las listas*/
		this.cargarInfo();

		/*Se obtiene la informacion que viaja por parametros para cargar el tercero*/
		this._route.params.subscribe( params =>{
			this.registroTercero = [{'cnumcont':params['cnumcont'], 
			'ctipid':params['ctipid'], 
			'cnumid':params['cnumid']}];
		}
		)

		
		
		this.mensaje = "Crear";
		this.tercero.id.cnumcont = this.registroTercero[0].cnumcont;
		this.creaSucursal = true;


	}

	
	inicializarForm(){
		this.form = this.formBuilder.group({			
			
			tipoId 	   : ['', Validators.required],
			numId : ['', Validators.required],
			digito : [{value:0,disabled:true}, Validators.required],
			nombre : ['', this.validarRequerido()],
			tipoPersona : ['', Validators.required],
			tipoContribuyente : ['', Validators.required],
			sucursal : ['', Validators.required],
			direccion : ['', Validators.required],
			pais : ['', Validators.required],
			departamento : ['', Validators.required],
			ciudad : ['', Validators.required],
			telefono : [''],
			correo : [''],
			responsibilidades : ['', Validators.required],
			tipoTributo      : ['', Validators.required],
			codigoPostal : ['', Validators.required],
			deptoextranjero : [
				{
					value   : this.sucursal.deptoextranjero,
					disabled: this.bloquearValor
				}, Validators.required
				],

				ciudadextranjero : [
					{
						value   : this.sucursal.ciudadextranjero,
						disabled: this.bloquearValor
					}, Validators.required
					],

		});
	}


	validarRequerido(){
		if(this.tercero.defTiposdocumentos.ctipid == '02' || this.tercero.defTiposdocumentos.ctipid == '07' || this.tercero.defTiposdocumentos.ctipid == '08'){
			return null;
		}else{
			return Validators.required;
		}
	}

	cargarInfo(){

		this._serviciosGenerales.get('responsabilidadesTributarias', { param: 0 }).subscribe(
			result => {
				for (let x of result){
					this.responsabilidadesFiscales.push(x.codigo);
				}
			},
			error => {
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar las Responsabilidades Tributarias", "X");
			}
		);
		

		
		this._serviciosGenerales.get('codigosPostales', { param: 0 }).subscribe(
			result => {
				for (let x of result){
					this.codigosPostales.push(x.codigo);
				}
			},
			error => {
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar los códigos postales", "X");
			}
		);


		this._serviciosGenerales.get('listaNegocios', {param:0}).subscribe(result =>{
			for(let x of result)
				this.listaNegocios.push(new OpcionModel(x.cnumcont, x.cnumcont));
			
		}, 
		error =>{
			var errorMensaje = <any>error;
			console.log('Error al enviar la peticion ', errorMensaje);
			this.openSnackBarEspecial("Ocurrió un error al momento de cargar los patrimonios", "X");

		});

		this._serviciosGenerales.get('tipoIdentificacion', {param:0}).subscribe(result =>{
			for(let x of result)
				this.tiposId.push(new OpcionModel(x.ctipid, x.vdescripcion));
			
		}, 
		error =>{
			var errorMensaje = <any>error;
			console.log('Error al enviar la peticion ', errorMensaje);
			this.openSnackBarEspecial("Ocurrió un error al momento de cargar los tipos de identificación", "X");

		});
		
		this._serviciosGenerales.get('tipoPersona', {param:0}).subscribe(result =>{
			for(let x of result)
				this.tiposPersonas.push(new OpcionModel(x.ntipper, x.vdescripcion));
			console.log(this.tiposPersonas);
			
			this.tercero.defTipospersona.ntipper = "1";
			console.log(this.tercero.defTipospersona.ntipper);
		}, 
		error =>{
			var errorMensaje = <any>error;
			console.log('Error al enviar la peticion ', errorMensaje);
			this.openSnackBarEspecial("Ocurrió un error al momento de cargar los tipos de persona", "X");

		});

		this._serviciosGenerales.get('tiposContribuyente', {param:0}).subscribe(result =>{
			for(let x of result)
				this.tiposContribuyente.push(new OpcionModel(x.nidcontribuyente, x.vdescripcion));
			
		}, 
		error =>{
			var errorMensaje = <any>error;
			console.log('Error al enviar la peticion ', errorMensaje);
			this.openSnackBarEspecial("Ocurrió un error al momento de cargar los tipos de contribuyente", "X");

		});	


		this._serviciosGenerales.get('paises', { param: 0 }).subscribe(
			result => {
				for (let x of result)
					this.paises.push(new OpcionModel(x.ccodigopais, x.vnombre));
			},
			error => {
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar los paises", "X");
			}
		);

/*
		this._serviciosGenerales.get('departamentos', {param:0}).subscribe(
			result =>{
				for(let x of result)
					this.departamentos.push(new OpcionModel(x.ccodigodepto, x.vnombre));
			}, 
			error =>{
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBar("Ocurrió un error al momento de cargar los tipos departamentos", "X");
			}
			);
*/
			this._serviciosGenerales.get('codigoTributo', {param:0}).subscribe(result =>{
				for(let x of result){
					this.tiposTributo.push(new OpcionModel(x.vcodigotri, x.vdescrip));
					console.log(x);
				}
				
			}, 
			error =>{
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar los tipos de contribuyente", "X");
	
			});	

		this._serviciosGenerales.getParametros('TERCEROS', this.tercero);


	}
	



	openSnackBar(message: string, action: string)
	{
		this.snackBar.open(message, action, {
			duration: 20000
		});
	}


	onFormValuesChanged()
	{
		for ( const field in this.formErrors )
		{
			if ( !this.formErrors.hasOwnProperty(field) )
			{
				continue;
			}

			// Clear previous errors
			this.formErrors[field] = {};

			// Get the control
			const control = this.form.get(field);

			if ( control && control.dirty && !control.valid )
			{
				this.formErrors[field] = control.errors;
			}
		}
	}


	consultarCiudades(id:number){
		this.ciudades = new Array();
		this.sucursal.defCiudades.id.ccodigociudad = 0;
		this._serviciosGenerales.get('ciudades', {ccodigodepto:this.sucursal.defCiudades.id.ccodigodepto}).subscribe(
			result =>{
				for(let x of result)
					this.ciudades.push(new OpcionModel(x.ccodigociudad, x.vnombre));
				/*if(id > -1)
					this.sucursal.defCiudades.id.ccodigociudad = id;*/
			}, 
			error =>{
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar las ciudades", "X");
			}
			);
	}


	consultarDepartamentos(id: number){
				
		this.departamentos = new Array();
		this.sucursal.defCiudades.id.ccodigodepto = "";
		this.sucursal.defCiudades.id.ccodigociudad = 0;


		
		this._serviciosGenerales.get('departamentosPorPais', { ccodigopais: this.sucursal.defCiudades.id.ccodigopais }).subscribe(
			result => {
				for (let x of result)
					this.departamentos.push(new OpcionModel(x.ccodigodepto, x.vnombre));
					this.validarCampo(true);	
			},
			error => {
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar las ciudades", "X");
			}
		);
	}


	calcularDV(nit) {
	if (this.tercero.defTiposdocumentos.ctipid =='02'){
		nit = nit.trim();
		var arreglo, x, y, z, i, nit1, dv1;
		console.log(nit, ' -- ', nit.indexOf('.'), ' -- ', nit.indexOf(','), ' -- ', nit.indexOf('-'), ' --- ', nit.indexOf(' '));
		if (nit.indexOf('.') > -1 || nit.indexOf(',') > -1 || nit.indexOf('-') > -1 || nit.indexOf(' ') > -1) {
			this.openSnackBarEspecial('Número de id no valido, ingrese un número sin puntos, ni comas, ni guiones, ni espacios','X');
		} else {
			arreglo = new Array(16);
			x = 0;
			y = 0;
			z = nit.length;
			arreglo[1] = 3;
			arreglo[2] = 7;
			arreglo[3] = 13;
			arreglo[4] = 17;
			arreglo[5] = 19;
			arreglo[6] = 23;
			arreglo[7] = 29;
			arreglo[8] = 37;
			arreglo[9] = 41;
			arreglo[10] = 43;
			arreglo[11] = 47;
			arreglo[12] = 53;
			arreglo[13] = 59;
			arreglo[14] = 67;
			arreglo[15] = 71;
			for (i = 0; z > i; i++) {
				y = (nit.substr(i, 1));
				x += (y * arreglo[z - i]);
			}
			y = x % 11;
			if (y > 1) {
				dv1 = 11 - y;
			} else {
				dv1 = y;
			}

			if(Number.isNaN(dv1)){
				dv1 = 0;
			}
			this.tercero.ndigchk = dv1;
			
		}
	}
	}


	validarTercero(){
		console.log({ctipid : this.tercero.defTiposdocumentos.ctipid.trim(), cnumid : this.tercero.id.cnumid.trim()});
		this._serviciosGenerales.get('validarTercero', {ctipid : this.tercero.defTiposdocumentos.ctipid.trim(), cnumid : this.tercero.id.cnumid.trim(), cnumcont : this.tercero.id.cnumcont }).subscribe(
			result=>{
				if(result[0].c > 0){
					this.openSnackBarEspecial('El tercero : '+this.tercero.defTiposdocumentos.ctipid.trim()+' - '+this.tercero.id.cnumid+' ya existe en el sistema', 'X');
				}
			},error=>{
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de validar el tercero", "X");
			})
	}

	guardar(){
		if(this.form.valid == false){
			this.openSnackBarEspecial('Hay Campos requeridos sin llenar', 'X');
			return;
		}

		var responFiscal = this.tercero.vresponfis.split(";");

		for (var c of responFiscal) {
			var resultado = this.responsabilidadesFiscales.find(function (x) {
				return x === c;
			});
			
			if(resultado == undefined){
				this.openSnackBarEspecial('El código  de Responsabilidad Fiscal : ' + c + ' No está definido  ', 'X');
				return;
			}
		}


		var sucursalCodigoPostal = this.sucursal.vpostal

			var resultado1 = this.codigosPostales.find(function (x) {
				return x === sucursalCodigoPostal;
			});
			
			if(resultado1 == undefined && this.sucursal.defCiudades.id.ccodigopais.trim()=='169'){
				this.openSnackBarEspecial('El código Postal : ' + sucursalCodigoPostal + ' No esta definido dentro de los posibles códigos postales del país.', 'X');
				return;
			}
		

		/*if(this.tercero.defTiposdocumentos.ctipid != '02' && this.tercero.defTiposdocumentos.ctipid != '07' && this.tercero.defTiposdocumentos.ctipid != '08'){
			if(this.tercero.vapellido.trim() == ''){
				this.openSnackBar('El primer apellido es requerido', 'X');
				return;		
			}
		}*/

		if (this.tercero.id.cnumid.indexOf('.') > -1 || this.tercero.id.cnumid.indexOf(',') > -1 || this.tercero.id.cnumid.indexOf('-') > -1 || this.tercero.id.cnumid.indexOf(' ') > -1) {
			this.openSnackBarEspecial('Número de id no valido, ingrese un número sin puntos, ni comas, ni guiones, ni espacios','X');
			return;
		} 

		
		if ((this.sucursal.defCiudades.id.ccodigociudad == 0 || this.sucursal.defCiudades.id.ccodigociudad == null)  && this.sucursal.defCiudades.id.ccodigopais=='169') {
			this.openSnackBarEspecial('Ciudad invalida, seleccione una ciudad de la lista','X');
			return;
		} 	

		var regex = new RegExp(/^[0-9]*$/);

		if (regex.test(this.sucursal.vtelefono) == false) {
			this.openSnackBar('Número de teléfono no valido, ingrese un número sin puntos, ni comas, ni guiones, ni espacios , ni letras ','X');
			return;
		} 	


		var reg = new RegExp(/[\w.+-]+@[\w.+-]+\.[a-zA-Z0-9]{2,4}(,\s*)*/ig);
		
		const myArray = this.sucursal.vcorreo.split(";");

		if(myArray.length >0){

				for(var item of myArray){
					if(validateisEmail(item) == false) {
						this.openSnackBarEspecial('Correo no valido, ingrese un correo una dirección de correo valida , además si desea ingresar varios correos estos deben estar separados por punto y coma ','X');
						return;
					} 
				}

		}else if(validateisEmail(this.sucursal.vcorreo) == false && JSON.parse(this._serviciosGenerales.seguridad.getInfoToken().ntipoempresa).ntipoempresa !=1) {
			this.openSnackBarEspecial('Correo no valido, ingrese un correo una dirección de correo valida , además si desea ingresar varios correos estos deben estar separados por punto y coma ','X');
			return;
		} 

		if(this.tercero.defTiposdocumentos.ctipid != '03' &&  this.tercero.defTiposdocumentos.ctipid !='05'  ){

			if (regex.test(this.tercero.id.cnumid) == false) {
				this.openSnackBarEspecial('Número de identificación no valido, ingrese un número sin puntos, ni comas, ni guiones, ni espacios , ni letras ','X');
				return;
			} 	
		
		}	

		if(this.tercero.defTiposdocumentos.ctipid == '01' ||  this.tercero.defTiposdocumentos.ctipid =='02'  ){

			if (999999 >= parseInt(this.tercero.id.cnumid)) {
				this.openSnackBarEspecial('Nro ID invalido, Subir Nro ID mayor a 999.999','X');
				return;
			} 	
		
		}
		
		this._serviciosGenerales.get('validarTercero', {ctipid : this.tercero.defTiposdocumentos.ctipid.trim(), cnumid : this.tercero.id.cnumid.trim(), cnumcont : this.tercero.id.cnumcont }).subscribe(
			result=>{
				if(result[0].c > 0){
					this.openSnackBarEspecial('El tercero : '+this.tercero.defTiposdocumentos.ctipid.trim()+' - '+this.tercero.id.cnumid+' ya existe en el sistema', 'X');
					return;
				}

				if(this.tercero.defContribuyentes.nidcontribuyente == undefined)
					this.tercero.defContribuyentes.nidcontribuyente = '';

				if(String(this.tercero.defContribuyentes.nidcontribuyente).trim() == ''){
					this.tercero.defContribuyentes.nidcontribuyente = '8';
				}

				this.guardarSinValidaciones();

			},error=>{
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de validar el tercero", "X");
			})
	}

	guardarSinValidaciones(){
		if(this.form.valid == false){
			this.openSnackBarEspecial('Hay Campos requeridos sin llenar', 'X');
			return;
		}
		
		//this.tercero.paramNegocios.id.cnumcont = this.tercero.id.cnumcont;
		this.tercero.id.ctipid = this.tercero.defTiposdocumentos.ctipid;
		this.sucursal.id.cnumcont = this.tercero.id.cnumcont
		this.sucursal.id.ctipid = this.tercero.id.ctipid
		this.sucursal.id.cnumid = this.tercero.id.cnumid

		this.tercero.nestado = (this.tercero.nestado == true ? 1 : 0);


		this._serviciosGenerales.post('guardar/tercero', this.tercero).subscribe(
			result =>{
				this.openSnackBar("Se creo el tercero "+this.tercero.vnombre+" "+this.tercero.vapellido+" "+this.tercero.vapellido2+" con éxito", "X");


				this.guardarSucursal();

				/*this.tercero = new TerceroNewModel.TerceroModel(new TerceroNewModel.DefTiposdocumentos(""),
					new TerceroNewModel.MchTercerosId("", "",""), 
					0,"","","",new TerceroNewModel.DefTipospersona(0),
					new TerceroNewModel.ParamNegocios(""),
					new TerceroNewModel.DefContribuyentes(0));

				this.sucursal = new SucursalNewModel.SucursalModel(new SucursalNewModel.MchSucursalesId("","","","","")
				,"","",new SucursalNewModel.DefDepartamentos("",""),new SucursalNewModel.DefCiudades("",0),"",0);*/


				this._router.navigate(['/Tercero',this.tercero.id.cnumcont]);
				
			}, 
			error =>{
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de guardar el tercero", "X");
			}

			)





	}
	

	guardarSucursal(){
		if(this.principal == false){
			this.sucursal.nprincipal = 0
		}else if(this.principal == true){
			this.sucursal.nprincipal = 1
		}

		this._serviciosGenerales.post('guardar/sucursal', this.sucursal).subscribe(
			result =>{
				//this.openSnackBar("Proceso realizado con éxito", "X");
				console.log(this.tercero);
				console.log(this.sucursal);
			}, 
			error =>{
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de guardar la sucursal", "X");
			}

			)
	}
	public validarCampo(x){
		
		console.log('vegeta ',this.sucursal.defCiudades.id.ccodigopais);

		if(this.sucursal.defCiudades.id.ccodigopais!='169'){

			this.bloquearValor = true;
			this.form.get('departamento').setValue('0');
			//this.consultarCiudades(0);
			//this.form.get('ciudad').setValue('0');
			this.form.get('departamento').disable();
			this.form.get('ciudad').disable();
			this.form.get('deptoextranjero').enable();
			this.form.get('ciudadextranjero').enable();
		
		}
		else{
			this.bloquearValor = false;
			//this.form.get('departamento').setValue('');
			this.form.get('departamento').enable();
			this.form.get('ciudad').enable();
			this.form.get('deptoextranjero').setValue('');
			this.form.get('ciudadextranjero').setValue('');
			this.form.get('deptoextranjero').disable();
			this.form.get('ciudadextranjero').disable();
		}
	}

	openSnackBarEspecial(message: string, action: string) {
		let snackBarRef =  this.snackBar.open(message, action);

		snackBarRef.onAction().subscribe(() => {
			console.log("Paso por aqui 1 notas");

			this.ocultar = false;
			this.mensaje = "";
		});
		
		let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;		
		
		if (shand.length != 0) {
			    for (let i=0;i<shand.length;i++){
				shand[i].style.backgroundColor = "rgb(255 204 214)";
				}
			}
	}

}


// WEBPACK FOOTER //
// D:/REPO/FacturacionWeb/src/app/main/content/Tercero/TerceroNew.component.ts